import { cn } from 'lib/helpers/utility';

import Icon from 'components/shared/Icon/Icon';

const VARIANT_STYLES = {
  default: 'text-neutral-500',
  warning: 'text-warning-600',
  danger: 'text-danger-600'
};

const StepDescription = ({ description }) => {
  if (!description?.text) return null;

  const variant = description.variant ?? 'default';

  return (
    <div className={cn('flex items-center gap-1 text-xs', VARIANT_STYLES[variant])}>
      {description.icon && <Icon icon={description.icon} size={12} />}
      <span className="truncate">{description.text}</span>
    </div>
  );
};

export default StepDescription;
